export default "__VITE_ASSET__TSO2sejl__"